export const SIDEBAR_OFFSET = 345;
